import { MAILING_DNS_SETTINGS_API } from 'modules/profile/mailing-settings/api/mailing-settings-domain-api'
import { MailingSettingsDomainsApiInterface } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import useSWR from 'swr'

interface useMailingDnsSettings extends SwrPaginationInterface {}

export function useMailingDnsSettings({ pagination, limit }: useMailingDnsSettings) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, MailingSettingsDomainsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: dnsMailingSettings, mutate } = useSWR(
    () => user && `${MAILING_DNS_SETTINGS_API}?${getPaginationQueryString({ pagination, limit })}`,
    fetcher,
  )

  return { dnsMailingSettings, mutate }
}
